import { Component } from '@angular/core';

import { ResolveLibModule } from 'resolve-lib';
import { Observable } from 'rxjs';
import { PageHeadingComponent } from '../../components/page-heading/page-heading.component';
import { RDataAggregatesComponent } from '../../components/rdata-aggregates/rdata-aggregates.component';

@Component({
    selector: 'app-rdata-aggregates-page',
    templateUrl: './rdata-aggregates.component.html',
    styleUrls: ['./rdata-aggregates.component.scss'],
    imports: [PageHeadingComponent, RDataAggregatesComponent, ResolveLibModule]
})
export class RDataAggregatesPage {
  userSpecialties$: Observable<Array<string>>;
}
